export type Status = {
  name: 'created' | 'updated' | 'error' | 'in_progress';
  percentage: number;
  color: string;
};

export const bulkUploadResultStatuses = {
  pending: '#4580FF',
  running: '#ED6C02',
  finished: '#2E7D32',
};

export function computeStatuses(
  totalAffected: number,
  totalCreated: number,
  totalUpdated: number,
  totalError: number,
): Status[] {
  const createdPercentage = Math.round((totalCreated / totalAffected) * 100);
  const updatedPercentage = Math.round((totalUpdated / totalAffected) * 100);
  const errorPercentage = Math.round((totalError / totalAffected) * 100);
  const inProgressPercentage = 100 - createdPercentage - updatedPercentage - errorPercentage;

  return [
    { name: 'created', percentage: createdPercentage, color: '#2E7D32' },
    { name: 'updated', percentage: updatedPercentage, color: '#4580FF' },
    { name: 'error', percentage: errorPercentage, color: '#D32F2F' },
    { name: 'in_progress', percentage: inProgressPercentage, color: '#AEAEAE' },
  ];
}
